module.exports = __webpack_public_path__ + "static/gap-adad8710dac110b98f01b222b1e11990.jpg";